var cov_2lhs8dfwvb = function () {
  var path = '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/home_page/homePageCtrl.js',
      hash = '0bc710048ffbe2d1719fa9e7b8ef9032114e0f42',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/home_page/homePageCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 429,
          column: 3
        }
      },
      '1': {
        start: {
          line: 2,
          column: 15
        },
        end: {
          line: 2,
          column: 35
        }
      },
      '2': {
        start: {
          line: 3,
          column: 29
        },
        end: {
          line: 3,
          column: 43
        }
      },
      '3': {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 4,
          column: 51
        }
      },
      '4': {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 43
        }
      },
      '5': {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 14,
          column: 5
        }
      },
      '6': {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 48
        }
      },
      '7': {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 17,
          column: 5
        }
      },
      '8': {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 33
        }
      },
      '9': {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 30,
          column: 5
        }
      },
      '10': {
        start: {
          line: 20,
          column: 15
        },
        end: {
          line: 20,
          column: 33
        }
      },
      '11': {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 28,
          column: 5
        }
      },
      '12': {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 27,
          column: 8
        }
      },
      '13': {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 32
        }
      },
      '14': {
        start: {
          line: 48,
          column: 2
        },
        end: {
          line: 50,
          column: 5
        }
      },
      '15': {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 33
        }
      },
      '16': {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 52,
          column: 53
        }
      },
      '17': {
        start: {
          line: 54,
          column: 2
        },
        end: {
          line: 57,
          column: 5
        }
      },
      '18': {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 32
        }
      },
      '19': {
        start: {
          line: 58,
          column: 27
        },
        end: {
          line: 165,
          column: 3
        }
      },
      '20': {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 33
        }
      },
      '21': {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 27
        }
      },
      '22': {
        start: {
          line: 61,
          column: 19
        },
        end: {
          line: 61,
          column: 21
        }
      },
      '23': {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 73,
          column: 5
        }
      },
      '24': {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 63,
          column: 64
        }
      },
      '25': {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 67,
          column: 7
        }
      },
      '26': {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 36
        }
      },
      '27': {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 43
        }
      },
      '28': {
        start: {
          line: 70,
          column: 6
        },
        end: {
          line: 72,
          column: 7
        }
      },
      '29': {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 71,
          column: 36
        }
      },
      '30': {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 87,
          column: 5
        }
      },
      '31': {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 60
        }
      },
      '32': {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 80,
          column: 7
        }
      },
      '33': {
        start: {
          line: 79,
          column: 8
        },
        end: {
          line: 79,
          column: 31
        }
      },
      '34': {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 82,
          column: 38
        }
      },
      '35': {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 86,
          column: 7
        }
      },
      '36': {
        start: {
          line: 85,
          column: 8
        },
        end: {
          line: 85,
          column: 36
        }
      },
      '37': {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 101,
          column: 5
        }
      },
      '38': {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 90,
          column: 56
        }
      },
      '39': {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 94,
          column: 7
        }
      },
      '40': {
        start: {
          line: 93,
          column: 8
        },
        end: {
          line: 93,
          column: 30
        }
      },
      '41': {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 37
        }
      },
      '42': {
        start: {
          line: 98,
          column: 6
        },
        end: {
          line: 100,
          column: 7
        }
      },
      '43': {
        start: {
          line: 99,
          column: 8
        },
        end: {
          line: 99,
          column: 36
        }
      },
      '44': {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 115,
          column: 5
        }
      },
      '45': {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 104,
          column: 54
        }
      },
      '46': {
        start: {
          line: 106,
          column: 6
        },
        end: {
          line: 108,
          column: 7
        }
      },
      '47': {
        start: {
          line: 107,
          column: 8
        },
        end: {
          line: 107,
          column: 28
        }
      },
      '48': {
        start: {
          line: 110,
          column: 6
        },
        end: {
          line: 110,
          column: 35
        }
      },
      '49': {
        start: {
          line: 112,
          column: 6
        },
        end: {
          line: 114,
          column: 7
        }
      },
      '50': {
        start: {
          line: 113,
          column: 8
        },
        end: {
          line: 113,
          column: 36
        }
      },
      '51': {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 128,
          column: 5
        }
      },
      '52': {
        start: {
          line: 118,
          column: 6
        },
        end: {
          line: 118,
          column: 55
        }
      },
      '53': {
        start: {
          line: 120,
          column: 6
        },
        end: {
          line: 122,
          column: 7
        }
      },
      '54': {
        start: {
          line: 121,
          column: 8
        },
        end: {
          line: 121,
          column: 29
        }
      },
      '55': {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 123,
          column: 36
        }
      },
      '56': {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 127,
          column: 7
        }
      },
      '57': {
        start: {
          line: 126,
          column: 8
        },
        end: {
          line: 126,
          column: 36
        }
      },
      '58': {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 143,
          column: 5
        }
      },
      '59': {
        start: {
          line: 131,
          column: 6
        },
        end: {
          line: 131,
          column: 59
        }
      },
      '60': {
        start: {
          line: 133,
          column: 6
        },
        end: {
          line: 137,
          column: 7
        }
      },
      '61': {
        start: {
          line: 134,
          column: 8
        },
        end: {
          line: 134,
          column: 34
        }
      },
      '62': {
        start: {
          line: 136,
          column: 8
        },
        end: {
          line: 136,
          column: 30
        }
      },
      '63': {
        start: {
          line: 138,
          column: 6
        },
        end: {
          line: 138,
          column: 36
        }
      },
      '64': {
        start: {
          line: 140,
          column: 6
        },
        end: {
          line: 142,
          column: 7
        }
      },
      '65': {
        start: {
          line: 141,
          column: 8
        },
        end: {
          line: 141,
          column: 36
        }
      },
      '66': {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 147,
          column: 5
        }
      },
      '67': {
        start: {
          line: 146,
          column: 6
        },
        end: {
          line: 146,
          column: 28
        }
      },
      '68': {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 150,
          column: 5
        }
      },
      '69': {
        start: {
          line: 149,
          column: 6
        },
        end: {
          line: 149,
          column: 28
        }
      },
      '70': {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 153,
          column: 5
        }
      },
      '71': {
        start: {
          line: 152,
          column: 6
        },
        end: {
          line: 152,
          column: 28
        }
      },
      '72': {
        start: {
          line: 154,
          column: 4
        },
        end: {
          line: 156,
          column: 5
        }
      },
      '73': {
        start: {
          line: 155,
          column: 6
        },
        end: {
          line: 155,
          column: 28
        }
      },
      '74': {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 159,
          column: 5
        }
      },
      '75': {
        start: {
          line: 158,
          column: 6
        },
        end: {
          line: 158,
          column: 28
        }
      },
      '76': {
        start: {
          line: 160,
          column: 4
        },
        end: {
          line: 162,
          column: 5
        }
      },
      '77': {
        start: {
          line: 161,
          column: 6
        },
        end: {
          line: 161,
          column: 28
        }
      },
      '78': {
        start: {
          line: 164,
          column: 4
        },
        end: {
          line: 164,
          column: 18
        }
      },
      '79': {
        start: {
          line: 167,
          column: 2
        },
        end: {
          line: 401,
          column: 4
        }
      },
      '80': {
        start: {
          line: 170,
          column: 21
        },
        end: {
          line: 170,
          column: 39
        }
      },
      '81': {
        start: {
          line: 171,
          column: 6
        },
        end: {
          line: 171,
          column: 32
        }
      },
      '82': {
        start: {
          line: 172,
          column: 6
        },
        end: {
          line: 176,
          column: 9
        }
      },
      '83': {
        start: {
          line: 180,
          column: 22
        },
        end: {
          line: 180,
          column: 40
        }
      },
      '84': {
        start: {
          line: 181,
          column: 6
        },
        end: {
          line: 181,
          column: 44
        }
      },
      '85': {
        start: {
          line: 183,
          column: 6
        },
        end: {
          line: 222,
          column: 9
        }
      },
      '86': {
        start: {
          line: 184,
          column: 23
        },
        end: {
          line: 208,
          column: 9
        }
      },
      '87': {
        start: {
          line: 195,
          column: 25
        },
        end: {
          line: 195,
          column: 65
        }
      },
      '88': {
        start: {
          line: 196,
          column: 12
        },
        end: {
          line: 196,
          column: 64
        }
      },
      '89': {
        start: {
          line: 197,
          column: 12
        },
        end: {
          line: 197,
          column: 330
        }
      },
      '90': {
        start: {
          line: 198,
          column: 12
        },
        end: {
          line: 198,
          column: 34
        }
      },
      '91': {
        start: {
          line: 199,
          column: 12
        },
        end: {
          line: 199,
          column: 49
        }
      },
      '92': {
        start: {
          line: 200,
          column: 12
        },
        end: {
          line: 200,
          column: 42
        }
      },
      '93': {
        start: {
          line: 202,
          column: 12
        },
        end: {
          line: 202,
          column: 60
        }
      },
      '94': {
        start: {
          line: 209,
          column: 8
        },
        end: {
          line: 209,
          column: 48
        }
      },
      '95': {
        start: {
          line: 210,
          column: 8
        },
        end: {
          line: 220,
          column: 9
        }
      },
      '96': {
        start: {
          line: 211,
          column: 10
        },
        end: {
          line: 211,
          column: 51
        }
      },
      '97': {
        start: {
          line: 212,
          column: 23
        },
        end: {
          line: 212,
          column: 32
        }
      },
      '98': {
        start: {
          line: 213,
          column: 10
        },
        end: {
          line: 219,
          column: 13
        }
      },
      '99': {
        start: {
          line: 221,
          column: 8
        },
        end: {
          line: 221,
          column: 49
        }
      },
      '100': {
        start: {
          line: 225,
          column: 22
        },
        end: {
          line: 225,
          column: 40
        }
      },
      '101': {
        start: {
          line: 226,
          column: 6
        },
        end: {
          line: 226,
          column: 49
        }
      },
      '102': {
        start: {
          line: 228,
          column: 6
        },
        end: {
          line: 311,
          column: 9
        }
      },
      '103': {
        start: {
          line: 229,
          column: 23
        },
        end: {
          line: 291,
          column: 9
        }
      },
      '104': {
        start: {
          line: 282,
          column: 22
        },
        end: {
          line: 282,
          column: 42
        }
      },
      '105': {
        start: {
          line: 283,
          column: 12
        },
        end: {
          line: 283,
          column: 36
        }
      },
      '106': {
        start: {
          line: 292,
          column: 8
        },
        end: {
          line: 292,
          column: 52
        }
      },
      '107': {
        start: {
          line: 293,
          column: 8
        },
        end: {
          line: 308,
          column: 9
        }
      },
      '108': {
        start: {
          line: 294,
          column: 10
        },
        end: {
          line: 294,
          column: 55
        }
      },
      '109': {
        start: {
          line: 295,
          column: 23
        },
        end: {
          line: 295,
          column: 32
        }
      },
      '110': {
        start: {
          line: 297,
          column: 25
        },
        end: {
          line: 297,
          column: 56
        }
      },
      '111': {
        start: {
          line: 298,
          column: 31
        },
        end: {
          line: 298,
          column: 68
        }
      },
      '112': {
        start: {
          line: 300,
          column: 10
        },
        end: {
          line: 303,
          column: 13
        }
      },
      '113': {
        start: {
          line: 304,
          column: 10
        },
        end: {
          line: 307,
          column: 13
        }
      },
      '114': {
        start: {
          line: 310,
          column: 8
        },
        end: {
          line: 310,
          column: 53
        }
      },
      '115': {
        start: {
          line: 314,
          column: 22
        },
        end: {
          line: 314,
          column: 40
        }
      },
      '116': {
        start: {
          line: 315,
          column: 6
        },
        end: {
          line: 315,
          column: 45
        }
      },
      '117': {
        start: {
          line: 316,
          column: 6
        },
        end: {
          line: 387,
          column: 9
        }
      },
      '118': {
        start: {
          line: 317,
          column: 23
        },
        end: {
          line: 317,
          column: 52
        }
      },
      '119': {
        start: {
          line: 319,
          column: 23
        },
        end: {
          line: 364,
          column: 9
        }
      },
      '120': {
        start: {
          line: 353,
          column: 22
        },
        end: {
          line: 353,
          column: 42
        }
      },
      '121': {
        start: {
          line: 354,
          column: 12
        },
        end: {
          line: 354,
          column: 36
        }
      },
      '122': {
        start: {
          line: 365,
          column: 8
        },
        end: {
          line: 365,
          column: 48
        }
      },
      '123': {
        start: {
          line: 366,
          column: 8
        },
        end: {
          line: 373,
          column: 9
        }
      },
      '124': {
        start: {
          line: 367,
          column: 10
        },
        end: {
          line: 372,
          column: 13
        }
      },
      '125': {
        start: {
          line: 374,
          column: 8
        },
        end: {
          line: 385,
          column: 9
        }
      },
      '126': {
        start: {
          line: 375,
          column: 23
        },
        end: {
          line: 375,
          column: 32
        }
      },
      '127': {
        start: {
          line: 376,
          column: 10
        },
        end: {
          line: 384,
          column: 11
        }
      },
      '128': {
        start: {
          line: 377,
          column: 12
        },
        end: {
          line: 379,
          column: 13
        }
      },
      '129': {
        start: {
          line: 378,
          column: 14
        },
        end: {
          line: 378,
          column: 55
        }
      },
      '130': {
        start: {
          line: 380,
          column: 12
        },
        end: {
          line: 383,
          column: 15
        }
      },
      '131': {
        start: {
          line: 386,
          column: 8
        },
        end: {
          line: 386,
          column: 49
        }
      },
      '132': {
        start: {
          line: 390,
          column: 6
        },
        end: {
          line: 390,
          column: 34
        }
      },
      '133': {
        start: {
          line: 391,
          column: 6
        },
        end: {
          line: 391,
          column: 38
        }
      },
      '134': {
        start: {
          line: 392,
          column: 6
        },
        end: {
          line: 392,
          column: 34
        }
      },
      '135': {
        start: {
          line: 395,
          column: 6
        },
        end: {
          line: 395,
          column: 78
        }
      },
      '136': {
        start: {
          line: 396,
          column: 6
        },
        end: {
          line: 396,
          column: 134
        }
      },
      '137': {
        start: {
          line: 398,
          column: 6
        },
        end: {
          line: 398,
          column: 34
        }
      },
      '138': {
        start: {
          line: 399,
          column: 6
        },
        end: {
          line: 399,
          column: 38
        }
      },
      '139': {
        start: {
          line: 403,
          column: 2
        },
        end: {
          line: 420,
          column: 4
        }
      },
      '140': {
        start: {
          line: 404,
          column: 4
        },
        end: {
          line: 419,
          column: 6
        }
      },
      '141': {
        start: {
          line: 421,
          column: 2
        },
        end: {
          line: 421,
          column: 22
        }
      },
      '142': {
        start: {
          line: 423,
          column: 2
        },
        end: {
          line: 426,
          column: 4
        }
      },
      '143': {
        start: {
          line: 424,
          column: 4
        },
        end: {
          line: 424,
          column: 24
        }
      },
      '144': {
        start: {
          line: 425,
          column: 4
        },
        end: {
          line: 425,
          column: 32
        }
      },
      '145': {
        start: {
          line: 428,
          column: 2
        },
        end: {
          line: 428,
          column: 30
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 49
          },
          end: {
            line: 1,
            column: 50
          }
        },
        loc: {
          start: {
            line: 1,
            column: 144
          },
          end: {
            line: 429,
            column: 1
          }
        },
        line: 1
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 12,
            column: 65
          },
          end: {
            line: 12,
            column: 66
          }
        },
        loc: {
          start: {
            line: 12,
            column: 73
          },
          end: {
            line: 14,
            column: 3
          }
        },
        line: 12
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 15,
            column: 55
          },
          end: {
            line: 15,
            column: 56
          }
        },
        loc: {
          start: {
            line: 15,
            column: 63
          },
          end: {
            line: 17,
            column: 3
          }
        },
        line: 15
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 19,
            column: 68
          },
          end: {
            line: 19,
            column: 69
          }
        },
        loc: {
          start: {
            line: 19,
            column: 77
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 19
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 48,
            column: 50
          },
          end: {
            line: 48,
            column: 51
          }
        },
        loc: {
          start: {
            line: 48,
            column: 58
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 48
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 54,
            column: 47
          },
          end: {
            line: 54,
            column: 48
          }
        },
        loc: {
          start: {
            line: 54,
            column: 55
          },
          end: {
            line: 57,
            column: 3
          }
        },
        line: 54
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 58,
            column: 27
          },
          end: {
            line: 58,
            column: 28
          }
        },
        loc: {
          start: {
            line: 58,
            column: 33
          },
          end: {
            line: 165,
            column: 3
          }
        },
        line: 58
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 62,
            column: 70
          },
          end: {
            line: 62,
            column: 71
          }
        },
        loc: {
          start: {
            line: 62,
            column: 86
          },
          end: {
            line: 64,
            column: 5
          }
        },
        line: 62
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 75,
            column: 66
          },
          end: {
            line: 75,
            column: 67
          }
        },
        loc: {
          start: {
            line: 75,
            column: 82
          },
          end: {
            line: 77,
            column: 5
          }
        },
        line: 75
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 89,
            column: 65
          },
          end: {
            line: 89,
            column: 66
          }
        },
        loc: {
          start: {
            line: 89,
            column: 78
          },
          end: {
            line: 91,
            column: 5
          }
        },
        line: 89
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 103,
            column: 63
          },
          end: {
            line: 103,
            column: 64
          }
        },
        loc: {
          start: {
            line: 103,
            column: 76
          },
          end: {
            line: 105,
            column: 5
          }
        },
        line: 103
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 117,
            column: 64
          },
          end: {
            line: 117,
            column: 65
          }
        },
        loc: {
          start: {
            line: 117,
            column: 77
          },
          end: {
            line: 119,
            column: 5
          }
        },
        line: 117
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 130,
            column: 66
          },
          end: {
            line: 130,
            column: 67
          }
        },
        loc: {
          start: {
            line: 130,
            column: 81
          },
          end: {
            line: 132,
            column: 5
          }
        },
        line: 130
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 183,
            column: 41
          },
          end: {
            line: 183,
            column: 42
          }
        },
        loc: {
          start: {
            line: 183,
            column: 49
          },
          end: {
            line: 222,
            column: 7
          }
        },
        line: 183
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 228,
            column: 41
          },
          end: {
            line: 228,
            column: 42
          }
        },
        loc: {
          start: {
            line: 228,
            column: 49
          },
          end: {
            line: 311,
            column: 7
          }
        },
        line: 228
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 316,
            column: 41
          },
          end: {
            line: 316,
            column: 42
          }
        },
        loc: {
          start: {
            line: 316,
            column: 49
          },
          end: {
            line: 387,
            column: 7
          }
        },
        line: 316
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 403,
            column: 22
          },
          end: {
            line: 403,
            column: 23
          }
        },
        loc: {
          start: {
            line: 403,
            column: 28
          },
          end: {
            line: 420,
            column: 3
          }
        },
        line: 403
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 423,
            column: 23
          },
          end: {
            line: 423,
            column: 24
          }
        },
        loc: {
          start: {
            line: 423,
            column: 29
          },
          end: {
            line: 426,
            column: 3
          }
        },
        line: 423
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        }, {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        }],
        line: 21
      },
      '1': {
        loc: {
          start: {
            line: 63,
            column: 13
          },
          end: {
            line: 63,
            column: 63
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 63,
            column: 13
          },
          end: {
            line: 63,
            column: 54
          }
        }, {
          start: {
            line: 63,
            column: 58
          },
          end: {
            line: 63,
            column: 63
          }
        }],
        line: 63
      },
      '2': {
        loc: {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 67,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 67,
            column: 7
          }
        }, {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 67,
            column: 7
          }
        }],
        line: 65
      },
      '3': {
        loc: {
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 72,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 72,
            column: 7
          }
        }, {
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 72,
            column: 7
          }
        }],
        line: 70
      },
      '4': {
        loc: {
          start: {
            line: 76,
            column: 13
          },
          end: {
            line: 76,
            column: 59
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 76,
            column: 13
          },
          end: {
            line: 76,
            column: 50
          }
        }, {
          start: {
            line: 76,
            column: 54
          },
          end: {
            line: 76,
            column: 59
          }
        }],
        line: 76
      },
      '5': {
        loc: {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 80,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 80,
            column: 7
          }
        }, {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 80,
            column: 7
          }
        }],
        line: 78
      },
      '6': {
        loc: {
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 86,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 86,
            column: 7
          }
        }, {
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 86,
            column: 7
          }
        }],
        line: 84
      },
      '7': {
        loc: {
          start: {
            line: 90,
            column: 13
          },
          end: {
            line: 90,
            column: 55
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 90,
            column: 13
          },
          end: {
            line: 90,
            column: 46
          }
        }, {
          start: {
            line: 90,
            column: 50
          },
          end: {
            line: 90,
            column: 55
          }
        }],
        line: 90
      },
      '8': {
        loc: {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 94,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 94,
            column: 7
          }
        }, {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 94,
            column: 7
          }
        }],
        line: 92
      },
      '9': {
        loc: {
          start: {
            line: 98,
            column: 6
          },
          end: {
            line: 100,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 98,
            column: 6
          },
          end: {
            line: 100,
            column: 7
          }
        }, {
          start: {
            line: 98,
            column: 6
          },
          end: {
            line: 100,
            column: 7
          }
        }],
        line: 98
      },
      '10': {
        loc: {
          start: {
            line: 104,
            column: 13
          },
          end: {
            line: 104,
            column: 53
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 104,
            column: 13
          },
          end: {
            line: 104,
            column: 44
          }
        }, {
          start: {
            line: 104,
            column: 48
          },
          end: {
            line: 104,
            column: 53
          }
        }],
        line: 104
      },
      '11': {
        loc: {
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 108,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 108,
            column: 7
          }
        }, {
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 108,
            column: 7
          }
        }],
        line: 106
      },
      '12': {
        loc: {
          start: {
            line: 112,
            column: 6
          },
          end: {
            line: 114,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 112,
            column: 6
          },
          end: {
            line: 114,
            column: 7
          }
        }, {
          start: {
            line: 112,
            column: 6
          },
          end: {
            line: 114,
            column: 7
          }
        }],
        line: 112
      },
      '13': {
        loc: {
          start: {
            line: 118,
            column: 13
          },
          end: {
            line: 118,
            column: 54
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 118,
            column: 13
          },
          end: {
            line: 118,
            column: 45
          }
        }, {
          start: {
            line: 118,
            column: 49
          },
          end: {
            line: 118,
            column: 54
          }
        }],
        line: 118
      },
      '14': {
        loc: {
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 122,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 122,
            column: 7
          }
        }, {
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 122,
            column: 7
          }
        }],
        line: 120
      },
      '15': {
        loc: {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 127,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 127,
            column: 7
          }
        }, {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 127,
            column: 7
          }
        }],
        line: 125
      },
      '16': {
        loc: {
          start: {
            line: 131,
            column: 13
          },
          end: {
            line: 131,
            column: 58
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 131,
            column: 13
          },
          end: {
            line: 131,
            column: 49
          }
        }, {
          start: {
            line: 131,
            column: 53
          },
          end: {
            line: 131,
            column: 58
          }
        }],
        line: 131
      },
      '17': {
        loc: {
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 137,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 137,
            column: 7
          }
        }, {
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 137,
            column: 7
          }
        }],
        line: 133
      },
      '18': {
        loc: {
          start: {
            line: 140,
            column: 6
          },
          end: {
            line: 142,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 140,
            column: 6
          },
          end: {
            line: 142,
            column: 7
          }
        }, {
          start: {
            line: 140,
            column: 6
          },
          end: {
            line: 142,
            column: 7
          }
        }],
        line: 140
      },
      '19': {
        loc: {
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 147,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 147,
            column: 5
          }
        }, {
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 147,
            column: 5
          }
        }],
        line: 145
      },
      '20': {
        loc: {
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 150,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 150,
            column: 5
          }
        }, {
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 150,
            column: 5
          }
        }],
        line: 148
      },
      '21': {
        loc: {
          start: {
            line: 151,
            column: 4
          },
          end: {
            line: 153,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 151,
            column: 4
          },
          end: {
            line: 153,
            column: 5
          }
        }, {
          start: {
            line: 151,
            column: 4
          },
          end: {
            line: 153,
            column: 5
          }
        }],
        line: 151
      },
      '22': {
        loc: {
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 156,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 156,
            column: 5
          }
        }, {
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 156,
            column: 5
          }
        }],
        line: 154
      },
      '23': {
        loc: {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 159,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 159,
            column: 5
          }
        }, {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 159,
            column: 5
          }
        }],
        line: 157
      },
      '24': {
        loc: {
          start: {
            line: 160,
            column: 4
          },
          end: {
            line: 162,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 160,
            column: 4
          },
          end: {
            line: 162,
            column: 5
          }
        }, {
          start: {
            line: 160,
            column: 4
          },
          end: {
            line: 162,
            column: 5
          }
        }],
        line: 160
      },
      '25': {
        loc: {
          start: {
            line: 197,
            column: 94
          },
          end: {
            line: 197,
            column: 163
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 197,
            column: 113
          },
          end: {
            line: 197,
            column: 137
          }
        }, {
          start: {
            line: 197,
            column: 140
          },
          end: {
            line: 197,
            column: 163
          }
        }],
        line: 197
      },
      '26': {
        loc: {
          start: {
            line: 297,
            column: 25
          },
          end: {
            line: 297,
            column: 56
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 297,
            column: 25
          },
          end: {
            line: 297,
            column: 48
          }
        }, {
          start: {
            line: 297,
            column: 52
          },
          end: {
            line: 297,
            column: 56
          }
        }],
        line: 297
      },
      '27': {
        loc: {
          start: {
            line: 298,
            column: 31
          },
          end: {
            line: 298,
            column: 68
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 298,
            column: 31
          },
          end: {
            line: 298,
            column: 60
          }
        }, {
          start: {
            line: 298,
            column: 64
          },
          end: {
            line: 298,
            column: 68
          }
        }],
        line: 298
      },
      '28': {
        loc: {
          start: {
            line: 302,
            column: 15
          },
          end: {
            line: 302,
            column: 86
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 302,
            column: 24
          },
          end: {
            line: 302,
            column: 79
          }
        }, {
          start: {
            line: 302,
            column: 82
          },
          end: {
            line: 302,
            column: 86
          }
        }],
        line: 302
      },
      '29': {
        loc: {
          start: {
            line: 306,
            column: 15
          },
          end: {
            line: 306,
            column: 98
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 306,
            column: 30
          },
          end: {
            line: 306,
            column: 91
          }
        }, {
          start: {
            line: 306,
            column: 94
          },
          end: {
            line: 306,
            column: 98
          }
        }],
        line: 306
      },
      '30': {
        loc: {
          start: {
            line: 377,
            column: 12
          },
          end: {
            line: 379,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 377,
            column: 12
          },
          end: {
            line: 379,
            column: 13
          }
        }, {
          start: {
            line: 377,
            column: 12
          },
          end: {
            line: 379,
            column: 13
          }
        }],
        line: 377
      },
      '31': {
        loc: {
          start: {
            line: 382,
            column: 17
          },
          end: {
            line: 382,
            column: 45
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 382,
            column: 17
          },
          end: {
            line: 382,
            column: 37
          }
        }, {
          start: {
            line: 382,
            column: 41
          },
          end: {
            line: 382,
            column: 45
          }
        }],
        line: 382
      },
      '32': {
        loc: {
          start: {
            line: 396,
            column: 43
          },
          end: {
            line: 396,
            column: 133
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 396,
            column: 103
          },
          end: {
            line: 396,
            column: 104
          }
        }, {
          start: {
            line: 396,
            column: 107
          },
          end: {
            line: 396,
            column: 133
          }
        }],
        line: 396
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0],
      '32': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_2lhs8dfwvb.s[0]++;
angular.module('app').controller('homePageCtrl', function ($scope, $CRUDService, $filter, $translate, $rootScope, $LOGINService, $deltaProjectStatus) {
  cov_2lhs8dfwvb.f[0]++;

  var PATH = (cov_2lhs8dfwvb.s[1]++, 'PortfolioDashboard');
  var PATH_CUSTOM_FIELDS = (cov_2lhs8dfwvb.s[2]++, 'CustomFields');
  cov_2lhs8dfwvb.s[3]++;
  $scope.currency = $rootScope.getGlobalCurrency();

  cov_2lhs8dfwvb.s[4]++;


  $scope.height = $('body').height() - 214;

  cov_2lhs8dfwvb.s[5]++;
  $CRUDService.getAll('Financement', { get: 'all', simple: true }, function (data) {
    cov_2lhs8dfwvb.f[1]++;
    cov_2lhs8dfwvb.s[6]++;

    $scope.listData_FinancialSource_bksb = data;
  });
  cov_2lhs8dfwvb.s[7]++;
  $CRUDService.getAll('AgenciesProject', { get: 'all' }, function (data) {
    cov_2lhs8dfwvb.f[2]++;
    cov_2lhs8dfwvb.s[8]++;

    $scope.agenciesFilter = data;
  });

  cov_2lhs8dfwvb.s[9]++;
  $CRUDService.getAll(PATH_CUSTOM_FIELDS, { get: 'single', type: 3 }, function (data_) {
    cov_2lhs8dfwvb.f[3]++;

    var data = (cov_2lhs8dfwvb.s[10]++, data_.VALUES_FIELD);
    cov_2lhs8dfwvb.s[11]++;
    if (!angular.isObject(data)) {
      cov_2lhs8dfwvb.b[0][0]++;
      cov_2lhs8dfwvb.s[12]++;

      data = [{ id: 1, name: $translate.instant('FINANCING.TYPES.GRANT') }, { id: 2, name: $translate.instant('FINANCING.TYPES.LOAN') }, { id: 3, name: $translate.instant('FINANCING.TYPES.DONATION') }, { id: 4, name: $translate.instant('FINANCING.TYPES.BUDGET_SUPPORT') }];
    } else {
      cov_2lhs8dfwvb.b[0][1]++;
    }
    cov_2lhs8dfwvb.s[13]++;
    $scope.typeFinancing = data;
  });

  cov_2lhs8dfwvb.s[14]++;


  $CRUDService.getAll('Projet', { get: 'devises' }, function (data) {
    cov_2lhs8dfwvb.f[4]++;
    cov_2lhs8dfwvb.s[15]++;

    $scope.currenciesList = data;
  });

  cov_2lhs8dfwvb.s[16]++;
  $scope.statutsList = $deltaProjectStatus.getList();

  cov_2lhs8dfwvb.s[17]++;
  $CRUDService.getAll('Sectors', { get: 'all' }, function (data) {
    cov_2lhs8dfwvb.f[5]++;
    cov_2lhs8dfwvb.s[18]++;

    $scope.sectorsFilter = data;
  });
  cov_2lhs8dfwvb.s[19]++;
  var processParameter = function processParameter() {
    cov_2lhs8dfwvb.f[6]++;
    cov_2lhs8dfwvb.s[20]++;

    $scope.filter.flitre = false;
    cov_2lhs8dfwvb.s[21]++;
    $scope.filter.nbre = 0;
    var params = (cov_2lhs8dfwvb.s[22]++, {});
    cov_2lhs8dfwvb.s[23]++;
    for (var _iterator = Object.keys($scope.filter.financingType).filter(function (financingKey) {
      cov_2lhs8dfwvb.f[7]++;
      cov_2lhs8dfwvb.s[24]++;

      return (cov_2lhs8dfwvb.b[1][0]++, $scope.filter.financingType[financingKey]) || (cov_2lhs8dfwvb.b[1][1]++, false);
    }), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var key = _ref;
      cov_2lhs8dfwvb.s[25]++;

      if (!params.type_financing) {
        cov_2lhs8dfwvb.b[2][0]++;
        cov_2lhs8dfwvb.s[26]++;

        params.type_financing = '0';
      } else {
        cov_2lhs8dfwvb.b[2][1]++;
      }

      cov_2lhs8dfwvb.s[27]++;
      params.type_financing += ' , ' + key;
      cov_2lhs8dfwvb.s[28]++;
      if ($scope.filter.financingType[key]) {
        cov_2lhs8dfwvb.b[3][0]++;
        cov_2lhs8dfwvb.s[29]++;

        $scope.filter.flitre = true;
      } else {
        cov_2lhs8dfwvb.b[3][1]++;
      }
    }

    cov_2lhs8dfwvb.s[30]++;
    for (var _iterator2 = Object.keys($scope.filter.financing).filter(function (financingKey) {
      cov_2lhs8dfwvb.f[8]++;
      cov_2lhs8dfwvb.s[31]++;

      return (cov_2lhs8dfwvb.b[4][0]++, $scope.filter.financing[financingKey]) || (cov_2lhs8dfwvb.b[4][1]++, false);
    }), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var _key = _ref2;
      cov_2lhs8dfwvb.s[32]++;

      if (!params.financing) {
        cov_2lhs8dfwvb.b[5][0]++;
        cov_2lhs8dfwvb.s[33]++;

        params.financing = '0';
      } else {
        cov_2lhs8dfwvb.b[5][1]++;
      }

      cov_2lhs8dfwvb.s[34]++;
      params.financing += ' , ' + _key;

      cov_2lhs8dfwvb.s[35]++;
      if ($scope.filter.financing[_key]) {
        cov_2lhs8dfwvb.b[6][0]++;
        cov_2lhs8dfwvb.s[36]++;

        $scope.filter.flitre = true;
      } else {
        cov_2lhs8dfwvb.b[6][1]++;
      }
    }

    cov_2lhs8dfwvb.s[37]++;
    for (var _iterator3 = Object.keys($scope.filter.agencies).filter(function (agencyKey) {
      cov_2lhs8dfwvb.f[9]++;
      cov_2lhs8dfwvb.s[38]++;

      return (cov_2lhs8dfwvb.b[7][0]++, $scope.filter.agencies[agencyKey]) || (cov_2lhs8dfwvb.b[7][1]++, false);
    }), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref3 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref3 = _i3.value;
      }

      var _key2 = _ref3;
      cov_2lhs8dfwvb.s[39]++;

      if (!params.agencies) {
        cov_2lhs8dfwvb.b[8][0]++;
        cov_2lhs8dfwvb.s[40]++;

        params.agencies = '0';
      } else {
        cov_2lhs8dfwvb.b[8][1]++;
      }

      cov_2lhs8dfwvb.s[41]++;
      params.agencies += ' , ' + _key2;

      cov_2lhs8dfwvb.s[42]++;
      if ($scope.filter.agencies[_key2]) {
        cov_2lhs8dfwvb.b[9][0]++;
        cov_2lhs8dfwvb.s[43]++;

        $scope.filter.flitre = true;
      } else {
        cov_2lhs8dfwvb.b[9][1]++;
      }
    }

    cov_2lhs8dfwvb.s[44]++;
    for (var _iterator4 = Object.keys($scope.filter.status).filter(function (statusKey) {
      cov_2lhs8dfwvb.f[10]++;
      cov_2lhs8dfwvb.s[45]++;

      return (cov_2lhs8dfwvb.b[10][0]++, $scope.filter.status[statusKey]) || (cov_2lhs8dfwvb.b[10][1]++, false);
    }), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
      var _ref4;

      if (_isArray4) {
        if (_i4 >= _iterator4.length) break;
        _ref4 = _iterator4[_i4++];
      } else {
        _i4 = _iterator4.next();
        if (_i4.done) break;
        _ref4 = _i4.value;
      }

      var _key3 = _ref4;
      cov_2lhs8dfwvb.s[46]++;

      if (!params.status) {
        cov_2lhs8dfwvb.b[11][0]++;
        cov_2lhs8dfwvb.s[47]++;

        params.status = '0';
      } else {
        cov_2lhs8dfwvb.b[11][1]++;
      }

      cov_2lhs8dfwvb.s[48]++;
      params.status += ' , ' + _key3;

      cov_2lhs8dfwvb.s[49]++;
      if ($scope.filter.status[_key3]) {
        cov_2lhs8dfwvb.b[12][0]++;
        cov_2lhs8dfwvb.s[50]++;

        $scope.filter.flitre = true;
      } else {
        cov_2lhs8dfwvb.b[12][1]++;
      }
    }

    cov_2lhs8dfwvb.s[51]++;
    for (var _iterator5 = Object.keys($scope.filter.sectors).filter(function (sectorKey) {
      cov_2lhs8dfwvb.f[11]++;
      cov_2lhs8dfwvb.s[52]++;

      return (cov_2lhs8dfwvb.b[13][0]++, $scope.filter.sectors[sectorKey]) || (cov_2lhs8dfwvb.b[13][1]++, false);
    }), _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray5) {
        if (_i5 >= _iterator5.length) break;
        _ref5 = _iterator5[_i5++];
      } else {
        _i5 = _iterator5.next();
        if (_i5.done) break;
        _ref5 = _i5.value;
      }

      var _key4 = _ref5;
      cov_2lhs8dfwvb.s[53]++;

      if (!params.sectors) {
        cov_2lhs8dfwvb.b[14][0]++;
        cov_2lhs8dfwvb.s[54]++;

        params.sectors = '0';
      } else {
        cov_2lhs8dfwvb.b[14][1]++;
      }
      cov_2lhs8dfwvb.s[55]++;
      params.sectors += ' , ' + _key4;

      cov_2lhs8dfwvb.s[56]++;
      if ($scope.filter.sectors[_key4]) {
        cov_2lhs8dfwvb.b[15][0]++;
        cov_2lhs8dfwvb.s[57]++;

        $scope.filter.flitre = true;
      } else {
        cov_2lhs8dfwvb.b[15][1]++;
      }
    }

    cov_2lhs8dfwvb.s[58]++;
    for (var _iterator6 = Object.keys($scope.filter.locations).filter(function (locationKey) {
      cov_2lhs8dfwvb.f[12]++;
      cov_2lhs8dfwvb.s[59]++;

      return (cov_2lhs8dfwvb.b[16][0]++, $scope.filter.locations[locationKey]) || (cov_2lhs8dfwvb.b[16][1]++, false);
    }), _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
      var _ref6;

      if (_isArray6) {
        if (_i6 >= _iterator6.length) break;
        _ref6 = _iterator6[_i6++];
      } else {
        _i6 = _iterator6.next();
        if (_i6.done) break;
        _ref6 = _i6.value;
      }

      var _key5 = _ref6;
      cov_2lhs8dfwvb.s[60]++;

      if (params.locations) {
        cov_2lhs8dfwvb.b[17][0]++;
        cov_2lhs8dfwvb.s[61]++;

        params.locations += ' , ';
      } else {
        cov_2lhs8dfwvb.b[17][1]++;
        cov_2lhs8dfwvb.s[62]++;

        params.locations = '';
      }
      cov_2lhs8dfwvb.s[63]++;
      params.locations += ' ' + _key5;

      cov_2lhs8dfwvb.s[64]++;
      if ($scope.filter.locations[_key5]) {
        cov_2lhs8dfwvb.b[18][0]++;
        cov_2lhs8dfwvb.s[65]++;

        $scope.filter.flitre = true;
      } else {
        cov_2lhs8dfwvb.b[18][1]++;
      }
    }

    cov_2lhs8dfwvb.s[66]++;
    if (Object.keys($scope.filter.financingType).length > 0) {
      cov_2lhs8dfwvb.b[19][0]++;
      cov_2lhs8dfwvb.s[67]++;

      $scope.filter.nbre++;
    } else {
      cov_2lhs8dfwvb.b[19][1]++;
    }
    cov_2lhs8dfwvb.s[68]++;
    if (Object.keys($scope.filter.financing).length > 0) {
      cov_2lhs8dfwvb.b[20][0]++;
      cov_2lhs8dfwvb.s[69]++;

      $scope.filter.nbre++;
    } else {
      cov_2lhs8dfwvb.b[20][1]++;
    }
    cov_2lhs8dfwvb.s[70]++;
    if (Object.keys($scope.filter.agencies).length > 0) {
      cov_2lhs8dfwvb.b[21][0]++;
      cov_2lhs8dfwvb.s[71]++;

      $scope.filter.nbre++;
    } else {
      cov_2lhs8dfwvb.b[21][1]++;
    }
    cov_2lhs8dfwvb.s[72]++;
    if (Object.keys($scope.filter.status).length > 0) {
      cov_2lhs8dfwvb.b[22][0]++;
      cov_2lhs8dfwvb.s[73]++;

      $scope.filter.nbre++;
    } else {
      cov_2lhs8dfwvb.b[22][1]++;
    }
    cov_2lhs8dfwvb.s[74]++;
    if (Object.keys($scope.filter.sectors).length > 0) {
      cov_2lhs8dfwvb.b[23][0]++;
      cov_2lhs8dfwvb.s[75]++;

      $scope.filter.nbre++;
    } else {
      cov_2lhs8dfwvb.b[23][1]++;
    }
    cov_2lhs8dfwvb.s[76]++;
    if (Object.keys($scope.filter.locations).length > 0) {
      cov_2lhs8dfwvb.b[24][0]++;
      cov_2lhs8dfwvb.s[77]++;

      $scope.filter.nbre++;
    } else {
      cov_2lhs8dfwvb.b[24][1]++;
    }

    cov_2lhs8dfwvb.s[78]++;
    return params;
  };

  cov_2lhs8dfwvb.s[79]++;
  $scope.process = {
    printData: function printData() {
      var params = (cov_2lhs8dfwvb.s[80]++, processParameter());
      cov_2lhs8dfwvb.s[81]++;
      params.get = 'print_data';
      cov_2lhs8dfwvb.s[82]++;
      $rootScope.printReport({
        link: PATH,
        params: params,
        title: $translate.instant('PROJECT.DASHBOARD_VIEW.DASHBOARD_TYPE.PROJECTS')
      });
    },
    financialRepartition: function financialRepartition() {
      var params_ = (cov_2lhs8dfwvb.s[83]++, processParameter());
      cov_2lhs8dfwvb.s[84]++;
      params_.get = 'financial_repartition';

      cov_2lhs8dfwvb.s[85]++;
      $CRUDService.getAll(PATH, params_, function (data) {
        cov_2lhs8dfwvb.f[13]++;

        var params = (cov_2lhs8dfwvb.s[86]++, {
          exportWithRightClick: true,
          locale: $LOGINService.getLang(),
          series: [{
            innerRadius: '60%',
            type: 'Pie', dataSource: [], xName: 'x', yName: 'y',
            dataLabel: { visible: true, position: 'Outside' },
            pointColorMapping: 'color'
          }], textRender: function textRender(args) {
            var item = (cov_2lhs8dfwvb.s[87]++, args.series.resultData[args.point.index]);
            cov_2lhs8dfwvb.s[88]++;
            args.point.customValue = args.point.x + '<br/><hr>';
            cov_2lhs8dfwvb.s[89]++;
            args.point.customValue += '<br/>' + $translate.instant('PROJECT.DASHBOARD_VIEW.' + (args.point.y > 1 ? (cov_2lhs8dfwvb.b[25][0]++, 'TOOLTIP_SECTOR_PLURALS') : (cov_2lhs8dfwvb.b[25][1]++, 'TOOLTIP_SECTOR_SINGLE')), { currency: $scope.filter.validateSelectedCurrency, amount: $filter('number')($scope.filter.validateExchangeRate * item.amount / 1000000), project: args.point.y });
            cov_2lhs8dfwvb.s[90]++;
            args.border.width = 1;
            cov_2lhs8dfwvb.s[91]++;
            args.border.color = args.point.color;
            cov_2lhs8dfwvb.s[92]++;
            args.color = args.point.color;

            cov_2lhs8dfwvb.s[93]++;
            args.text = args.point.x + ' (' + args.point.y + ')';
          },

          legendSettings: { visible: false, position: 'Bottom' }, enableSmartLabels: true,
          title_: $translate.instant('PROJECT.DASHBOARD_VIEW.PROJECT_BY_SECTOR'),

          tooltip: { enable: true, format: '${point.customValue}' }
        });
        cov_2lhs8dfwvb.s[94]++;
        $scope.financialRepartitionEmpty = true;
        cov_2lhs8dfwvb.s[95]++;
        for (var key in data) {
          cov_2lhs8dfwvb.s[96]++;

          $scope.financialRepartitionEmpty = false;
          var item = (cov_2lhs8dfwvb.s[97]++, data[key]);
          cov_2lhs8dfwvb.s[98]++;
          params.series[0].dataSource.push({
            x: item.NAME,
            y: item.NBR,
            amount: item.AMOUNT,
            disbursed: item.DISBURSED,
            color: 'rgb(' + item.COLOR + ')'
          });
        }
        cov_2lhs8dfwvb.s[99]++;
        $scope.financialRepartitionData = params;
      });
    },
    fundingSourceRepartition: function fundingSourceRepartition() {
      var params_ = (cov_2lhs8dfwvb.s[100]++, processParameter());
      cov_2lhs8dfwvb.s[101]++;
      params_.get = 'funding_source_repartition';

      cov_2lhs8dfwvb.s[102]++;
      $CRUDService.getAll(PATH, params_, function (data) {
        cov_2lhs8dfwvb.f[14]++;

        var params = (cov_2lhs8dfwvb.s[103]++, {
          exportWithRightClick: true,
          locale: $LOGINService.getLang(),

          primaryXAxis: {
            interval: 1,
            labelIntersectAction: 'Rotate45',
            valueType: 'Category',
            majorGridLines: { width: 0 }, minorGridLines: { width: 0 },
            majorTickLines: { width: 0 }, minorTickLines: { width: 0 },
            lineStyle: { width: 0 },
            maximumLabelWidth: 100,
            labelStyle: {
              color: '#728EB8',
              fontFamily: 'DM Sans'
            }
          },
          primaryYAxis: {
            valueType: 'Double',
            lineStyle: { width: 0 },
            majorTickLines: { width: 0 }, majorGridLines: { width: 1 },
            minorGridLines: { width: 1 }, minorTickLines: { width: 0 },
            labelFormat: '{value}',
            labelStyle: {
              color: '#728EB8',
              fontFamily: 'DM Sans'
            }
          },
          chartArea: {
            border: {
              width: 0
            }
          },
          useGroupingSeparator: true,

          series: [{
            type: 'Area',
            dataSource: [],
            xName: 'x', yName: 'y', name: $translate.instant('PROJECT.DASHBOARD_VIEW.AMOUNT'),
            width: 2,
            fill: '#80E144',
            opacity: 0.5
          }, {
            type: 'Line',
            dataSource: [],
            xName: 'x', yName: 'y', name: $translate.instant('PROJECT.DASHBOARD_VIEW.DISBURSED'),
            width: 2
          }],
          height: '100%',
          axisLabelRender: function axisLabelRender(args) {
            var _ = (cov_2lhs8dfwvb.s[104]++, args.text.split(':'));
            cov_2lhs8dfwvb.s[105]++;
            args.text = _[0].trim();
          },

          title_: $translate.instant('PROJECT.DASHBOARD_VIEW.INVESTING_BY_FUNDING_SOURCE') + ' (' + $translate.instant('PROJECT.DASHBOARD_VIEW.DECIMAL_CURRENCY', { currency: $scope.filter.validateSelectedCurrency }) + ')',
          legendSettings: {
            visible: true
          },
          tooltip: { enable: true, format: '${series.name}: ${point.y}', shared: true }
        });
        cov_2lhs8dfwvb.s[106]++;
        $scope.fundingSourceRepartitionEmpty = true;
        cov_2lhs8dfwvb.s[107]++;
        for (var key in data) {
          cov_2lhs8dfwvb.s[108]++;

          $scope.fundingSourceRepartitionEmpty = false;
          var item = (cov_2lhs8dfwvb.s[109]++, data[key]);

          var amount = (cov_2lhs8dfwvb.s[110]++, (cov_2lhs8dfwvb.b[26][0]++, parseFloat(item.AMOUNT)) || (cov_2lhs8dfwvb.b[26][1]++, null));
          var disbursement = (cov_2lhs8dfwvb.s[111]++, (cov_2lhs8dfwvb.b[27][0]++, parseFloat(item.DISBURSEMENT)) || (cov_2lhs8dfwvb.b[27][1]++, null));

          cov_2lhs8dfwvb.s[112]++;
          params.series[0].dataSource.push({
            x: item.label,
            y: amount ? (cov_2lhs8dfwvb.b[28][0]++, $scope.filter.validateExchangeRate * amount / 1000000) : (cov_2lhs8dfwvb.b[28][1]++, null)
          });
          cov_2lhs8dfwvb.s[113]++;
          params.series[1].dataSource.push({
            x: item.label,
            y: disbursement ? (cov_2lhs8dfwvb.b[29][0]++, $scope.filter.validateExchangeRate * disbursement / 1000000) : (cov_2lhs8dfwvb.b[29][1]++, null)
          });
        }

        cov_2lhs8dfwvb.s[114]++;
        $scope.fundingSourceRepartitionData = params;
      });
    },
    fundingSourceProject: function fundingSourceProject() {
      var params_ = (cov_2lhs8dfwvb.s[115]++, processParameter());
      cov_2lhs8dfwvb.s[116]++;
      params_.get = 'funding_source_project';
      cov_2lhs8dfwvb.s[117]++;
      $CRUDService.getAll(PATH, params_, function (data) {
        cov_2lhs8dfwvb.f[15]++;

        var labels = (cov_2lhs8dfwvb.s[118]++, $deltaProjectStatus.getList());

        var params = (cov_2lhs8dfwvb.s[119]++, {
          exportWithRightClick: true,
          locale: $LOGINService.getLang(),

          primaryXAxis: {
            interval: 1,
            labelIntersectAction: 'Rotate45',
            valueType: 'Category',
            majorGridLines: { width: 0 }, minorGridLines: { width: 0 },
            majorTickLines: { width: 0 }, minorTickLines: { width: 0 },
            lineStyle: { width: 0 },
            maximumLabelWidth: 100
          },
          primaryYAxis: {
            valueType: 'Double',
            lineStyle: { width: 0 },
            majorTickLines: { width: 0 }, majorGridLines: { width: 1 },
            minorGridLines: { width: 1 }, minorTickLines: { width: 0 },
            labelFormat: 'N'
          },
          chartArea: {
            border: {
              width: 0
            }
          },

          useGroupingSeparator: true,

          series: [],
          height: '100%',
          axisLabelRender: function axisLabelRender(args) {
            var _ = (cov_2lhs8dfwvb.s[120]++, args.text.split(':'));
            cov_2lhs8dfwvb.s[121]++;
            args.text = _[0].trim();
          },

          title_: $translate.instant('PROJECT.DASHBOARD_VIEW.PROJECT_BY_FUNDING_SOURCE'),

          legendSettings: {
            visible: true
          },
          tooltip: { enable: true, format: '${series.name}: ${point.y} ' + $translate.instant('ACTIVITY.PROJECT') + '(s)', shared: true }
        });
        cov_2lhs8dfwvb.s[122]++;
        $scope.fundingSourceProjectEmpty = true;
        cov_2lhs8dfwvb.s[123]++;
        for (var _iterator7 = labels, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
          var _ref7;

          if (_isArray7) {
            if (_i7 >= _iterator7.length) break;
            _ref7 = _iterator7[_i7++];
          } else {
            _i7 = _iterator7.next();
            if (_i7.done) break;
            _ref7 = _i7.value;
          }

          var _label = _ref7;
          cov_2lhs8dfwvb.s[124]++;

          params.series.push({
            type: 'Column',
            dataSource: [],
            xName: 'x', yName: 'y', name: _label.name,
            width: 3
          });
        }
        cov_2lhs8dfwvb.s[125]++;
        for (var key in data) {
          var item = (cov_2lhs8dfwvb.s[126]++, data[key]);
          cov_2lhs8dfwvb.s[127]++;
          for (var _iterator8 = labels, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
            var _ref8;

            if (_isArray8) {
              if (_i8 >= _iterator8.length) break;
              _ref8 = _iterator8[_i8++];
            } else {
              _i8 = _iterator8.next();
              if (_i8.done) break;
              _ref8 = _i8.value;
            }

            var label = _ref8;
            cov_2lhs8dfwvb.s[128]++;

            if (item[label.id + '_']) {
              cov_2lhs8dfwvb.b[30][0]++;
              cov_2lhs8dfwvb.s[129]++;

              $scope.fundingSourceProjectEmpty = false;
            } else {
              cov_2lhs8dfwvb.b[30][1]++;
            }
            cov_2lhs8dfwvb.s[130]++;
            params.series[label.id - 1].dataSource.push({
              x: item.label,
              y: (cov_2lhs8dfwvb.b[31][0]++, item[label.id + '_']) || (cov_2lhs8dfwvb.b[31][1]++, null)
            });
          }
        }
        cov_2lhs8dfwvb.s[131]++;
        $scope.fundingSourceProjectData = params;
      });
    },
    processAll: function processAll() {
      cov_2lhs8dfwvb.s[132]++;

      this.financialRepartition();
      cov_2lhs8dfwvb.s[133]++;
      this.fundingSourceRepartition();
      cov_2lhs8dfwvb.s[134]++;
      this.fundingSourceProject();
    },
    validateRate: function validateRate() {
      cov_2lhs8dfwvb.s[135]++;

      $scope.filter.validateSelectedCurrency = $scope.filter.selectedCurrency;
      cov_2lhs8dfwvb.s[136]++;
      $scope.filter.validateExchangeRate = $scope.currency == $scope.filter.validateSelectedCurrency ? (cov_2lhs8dfwvb.b[32][0]++, 1) : (cov_2lhs8dfwvb.b[32][1]++, $scope.filter.exchangeRate);

      cov_2lhs8dfwvb.s[137]++;
      this.financialRepartition();
      cov_2lhs8dfwvb.s[138]++;
      this.fundingSourceRepartition();
    }
  };

  cov_2lhs8dfwvb.s[139]++;
  $scope.initFilter = function () {
    cov_2lhs8dfwvb.f[16]++;
    cov_2lhs8dfwvb.s[140]++;

    $scope.filter = {
      nbre: 0,
      flitre: false,
      display: false,
      financing: {},
      financingType: {},
      displayPanel: 1,
      agencies: {},
      status: {},
      sectors: {},
      locations: {},
      selectedCurrency: $scope.currency,
      exchangeRate: 1,
      validateSelectedCurrency: $scope.currency,
      validateExchangeRate: 1
    };
  };
  cov_2lhs8dfwvb.s[141]++;
  $scope.initFilter();

  cov_2lhs8dfwvb.s[142]++;
  $scope.clearFilter = function () {
    cov_2lhs8dfwvb.f[17]++;
    cov_2lhs8dfwvb.s[143]++;

    $scope.initFilter();
    cov_2lhs8dfwvb.s[144]++;
    $scope.process.processAll();
  };

  cov_2lhs8dfwvb.s[145]++;
  $scope.process.processAll();
});